/**
 * The scope marker of personal-tag responses (see api/customerPanel.ts and lib/personalTags.ts):
 * the server marks every response that carries the signed-in account's own tags with it, and the
 * interface shows tags only under it.
 */
export const PERSONAL_TAG_SCOPE = 'personal';
